import { render } from "./BrandnameComponent.vue?vue&type=template&id=0da58e37"
import script from "./BrandnameComponent.vue?vue&type=script&lang=js"
export * from "./BrandnameComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__